import type { replayIntegration } from "@sentry/remix";
import log from "../logging/log";
import isNil from "../validation/isNil";
import isPresent from "../validation/isPresent";

type Recorder = ReturnType<typeof replayIntegration>;

let recorder: Recorder | undefined;
let hasStarted = false;

export function registerSessionReplayRecorder(newRecorder: Recorder) {
  recorder = newRecorder;
}

export function startSessionReplay() {
  if (hasStarted || isNil(recorder)) {
    return;
  }

  hasStarted = true;
  promoteToSessionRecording(recorder).catch((error) => {
    hasStarted = false;
    log.error("Failed to start session replay", error);
  });
}

async function promoteToSessionRecording(recorder: Recorder) {
  if (isPresent(recorder.getReplayId())) {
    return recorder.flush();
  }

  recorder.start();
}
